
import React, { Component } from "react";
import ic_no_data from "../../assets/ic_no_data.svg";
import UserEntity from "../../types/userEntity.type";


type Props = {};

type State = {
  content: UserEntity[] | null;
}

export default class EmptyModeratorsView extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      content: null
    };
  }
  render(){
    return<>
      <div>
        <img src={ic_no_data} />
        <p>We didnt find any registred moderator</p>
      </div>
    </>
  }
}